import { Size } from "@repo/ui/helpers/helpers";
import { entityTable } from "@repo/ui/tables/entityTable";
import type { FC, ReactNode } from "react";

export interface SettingsTableHeaderCellProps {
  className?: string;
  colSpan?: number;
  children: ReactNode;
}

export const SettingsTableHeaderCell: FC<SettingsTableHeaderCellProps> = (
  props,
) => (
  <th
    scope="col"
    colSpan={props.colSpan}
    className={entityTable({ size: Size.SMALL }).column({
      className: props.className,
    })}
  >
    {props.children}
  </th>
);
